import ChessRestClient from '@/Api/ChessRestClient';
import {useMutation} from '@tanstack/react-query';

export type PauseCsocSubscriptionPayload = {
  order_id: string;
  pause_end_date: string; // dd/mm/yyyy
  paused_by_student?: boolean;
};

export default function usePauseCsocSubscription(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation({
    mutationFn: async (payload: PauseCsocSubscriptionPayload) => {
      const response = await ChessRestClient.post(
        'subscription/v1/csoc/pause-subscription',
        payload,
      );
      return response.data;
    },
    onSuccess: data => {
      if (handleOnSuccess) handleOnSuccess(data);
    },
    onError: error => {
      if (handleOnError) handleOnError(error);
    },
  });

  return {
    ...mutation,
  };
}
